import { ActionBoxState, ActionBoxStatus, ActionBoxTitleStatus } from "../reducers/actionBox";
import { safeBoolean } from "./utils";


export const actionBoxStatus = (actionBox?: ActionBoxStatus, key?: string) => actionBox && key && actionBox[key]

export const isPurchasingSeason = (abs?: ActionBoxTitleStatus) => {
  return Boolean(abs && safeBoolean(abs.isSeasonPurchase) && abs.state === ActionBoxState.purchasing)
}

export const epPurchasingText = (abs?: ActionBoxTitleStatus) => {
  return abs && abs.purchasingText
}

export const isPurchasingEpisode = (abs?: ActionBoxTitleStatus) => {
  return Boolean(abs && abs.state === ActionBoxState.purchasing)
}

